'use client';

import type {
  ComponentPropsWithoutRef,
  MouseEvent,
  ReactNode,
  Ref,
} from 'react';

import classnames from 'classnames';

import { activateOnKey } from '../../../utils/keyboard';
import type { BaseComponentProps } from '../../base-component.types';
import { Icon } from '../../icon';

import styles from './MenuItem.module.scss';

export type MenuItemProps = ComponentPropsWithoutRef<'li'> &
  BaseComponentProps & {
    children?: ReactNode;
    icon?: ReactNode;
    active?: boolean;
    prefix?: ReactNode;
    suffix?: ReactNode;
  };

export function BottomTabMenuItem({
  style,
  children,
  className,
  icon,
  prefix,
  suffix,
  testId = 'ui-bottom-tab-navbar_menu-item',
  ref,
  ...rest
}: MenuItemProps & { ref?: Ref<HTMLLIElement> }) {
  return (
    <li
      style={style}
      ref={ref}
      data-testid={testId}
      className={classnames(styles['navbar-menu-item'], className)}
      {...rest}
    >
      <div
        tabIndex={0}
        role="button"
        className={styles['inner-item']}
        onKeyDown={activateOnKey}
      >
        {icon && <Icon icon={icon} size="sm" />}
        {prefix && <span className={styles['prefix-wrapper']}>{prefix}</span>}
        {children && (
          <span className={styles['content-wrapper']}>{children}</span>
        )}
        {suffix && (
          <span
            className={styles['suffix-wrapper']}
            onClick={(event: MouseEvent<HTMLElement>) => {
              event.stopPropagation();
            }}
          >
            {suffix}
          </span>
        )}
      </div>
    </li>
  );
}
